/*
 * Copyright (c) 2023 Bolmate B.V.
 */

import {DialogActions} from '@dvrd/dvr-controls/src/js/dialog/dialogController';

import React, {useEffect, useRef} from 'react';

import ValidationErrors from '../components/misc/validationErrors';

import {showDialog} from '@dvrd/dvr-controls';

import i18n from '../i18n';

export const useIsFirstRender = () => {
    const isFirstRender = useRef(true);

    useEffect(() => {
        isFirstRender.current = false;
    }, []);

    return isFirstRender.current;
};

export function showValidationErrors(errors: Array<string>, config?: {title?: string; actions?: DialogActions}) {
    const title = config?.title ?? i18n.t('util.component.validationErrors', 'Validatiefouten');
    showDialog(<ValidationErrors errors={errors} />, title, config?.actions);
}
